"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXRemarks = exports.HTMLRemarks = exports.HTMLRemarksCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const paragraphItem_1 = require("./paragraphItem");
const common_1 = require("../common");
exports.HTMLRemarksCSS = `
.remarks {
    clear: both;
}

.remarks-label {
    clear: both;
    font-weight: bold;
}

`;
exports.HTMLRemarks = (0, html_1.wrapHTMLComponent)("HTMLRemarks", ((props) => {
    const { el, htmlOptions, indent } = props;
    const blocks = [];
    const RemarksLabel = el.children.find(std.isRemarksLabel);
    if (RemarksLabel) {
        blocks.push((react_1.default.createElement("div", { className: `remarks-label indent-${indent}`, ...(0, html_1.elProps)(RemarksLabel, htmlOptions) },
            react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: RemarksLabel.children, htmlOptions }))));
    }
    const bodyBlocks = [];
    for (const child of el.children) {
        if (std.isRemarksLabel(child)) {
            continue;
        }
        else if (std.isSentence(child)) {
            bodyBlocks.push((react_1.default.createElement("div", { className: `remarks-sentence indent-${indent + 1}`, ...(0, html_1.elProps)(child, htmlOptions) },
                react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: child.children, htmlOptions }))));
        }
        else if (std.isItem(child)) {
            bodyBlocks.push((react_1.default.createElement(paragraphItem_1.HTMLParagraphItem, { el: child, indent: indent + 1, htmlOptions })));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    if (bodyBlocks.length > 0) {
        blocks.push((react_1.default.createElement("div", { className: "remarks-body" }, (0, common_1.withKey)(bodyBlocks))));
    }
    return (react_1.default.createElement("div", { className: "remarks", ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
}));
exports.DOCXRemarks = (0, component_1.wrapDOCXComponent)("DOCXRemarks", ((props) => {
    const { el, docxOptions, indent } = props;
    const blocks = [];
    const RemarksLabel = el.children.find(std.isRemarksLabel);
    if (RemarksLabel) {
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null,
                react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
            react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: RemarksLabel.children, emphasis: true, docxOptions }))));
    }
    for (const child of el.children) {
        if (std.isRemarksLabel(child)) {
            continue;
        }
        else if (std.isSentence(child)) {
            blocks.push((react_1.default.createElement(tags_1.w.p, null,
                react_1.default.createElement(tags_1.w.pPr, null,
                    react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent + 1}` })),
                react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: child.children, docxOptions }))));
        }
        else if (std.isItem(child)) {
            blocks.push(react_1.default.createElement(paragraphItem_1.DOCXParagraphItem, { el: child, indent: indent + 1, docxOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
//# sourceMappingURL=remarks.js.map